/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The styled components for ChartCategoryLabel
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../../theme';

export const ChartCategoryLabelStyled = styled.div.attrs({
    'className': 'chart-category__label',
    'data-name': 'chartLabelCategory',
})`
    position: relative;
    z-index: 1;
    display: flex;
    margin: -16px 0 0 auto;
    background: ${colors.backgroundColorWhite};
`;

export const ChartCategoryLabelItemStyled = styled.div.attrs({
    className: 'chart-category__label-item',
})`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 9px 8px;
    border: 1px solid ${colors.borderColorDisabled};
    box-sizing: border-box;
    text-align: center;
    :first-child { border-right: none; }
    :last-child { border-left: none; }
`;

export const ChartCategoryCityTextStyled = styled.span.attrs({
    className: 'chart-category__text-city',
})`
    ${fonts.textSmall};
    color: ${colors.textColorOpacity};
`;
